export default (id, title, img, variants, qty, price, pennies, curr, line) =>
  `
        <div class="c-cart__item  o-layout  o-layout--full  o-flex">
            <div class="o-layout__item  u-1/3">
                <div class="c-cart__image  o-media">
                    <img src="${img}" alt="${title}">
                </div>
            </div>
            <div class="c-cart__text  o-layout__item  u-2/3">
                <p class="c-cart__title">${title} ${variants[0].includes('Default') ? '' : `: ${variants[0]}`}</p>
                <p class="c-cart__price  t-price  t-price--small"><sub>${curr}</sub>${price}&middot;<sub>${pennies}</sub></p>

                <div class="c-cart__qty">

                            <div class="c-qty__wrapper">
                                <button type="button" class="c-qty  c-qty--minus" data-qty="${qty - 1}" data-line="${line}">
                                    &ndash;
                                </button>
                                <input type="number" name="updates[]" id="" value="${qty}" min="1" class="c-qty  c-qty--input" data-id="${id}" readonly>
                                <button type="button" class="c-qty  c-qty--plus" data-qty="${qty + 1}" data-line="${line}">
                                    +
                                </button>
                            </div>

                </div>
            </div>
        </div>
    `
